import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media screen and (max-width: 560px) {
    margin: 0 40px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0;
  }

  > span {
    margin: 16px 0 10px 0;
  }

  > div {
    width: 255px;
    margin-bottom: 8px;
    text-align: center;
  }
`;
